import { gql } from "@apollo/client";

export const createConnectionBulk = gql`
    mutation createConnectionBulk($createRequests: [InputCreateConnectionRequest]!) {
        createConnectionBulk(input: { createRequests: $createRequests }) {
            connections {
                connectionId
                priority
                vendorData {
                    key
                    value
                }
                group {
                    totalNumLenses
                    name
                    id
                }
                lens {
                    removed
                    compoundId {
                        id
                        reference
                        lensSourceType
                    }
                }
                schedule {
                    scheduleStart {
                        seconds
                    }
                    scheduleEnd {
                        seconds
                    }
                    useClientTimezone
                }
            }
        }
    }
`;
